import loader from 'containers/modalsDispatcher/loader';

export const UPDATE_APP_NOTIFY_MODAL_KEY = 'UPDATE_APP_NOTIFY_MODAL';

export const showUpdateAppNotifyModal = loader({
  key: UPDATE_APP_NOTIFY_MODAL_KEY,
  getModal: () => import(/* update-app-notify-modal */'./UpdateAppNotifyModal'),
});
